module.exports = __webpack_public_path__ + "media/assets/images/tour/8b_Tour_4-e64539bce4a95e31f3e7b4baa015019d.png";